import React, { useEffect, useState } from 'react'

import type { DefaultProps } from '@/types/common'

import S from './_CheckboxGroup.style'
import { CheckboxGroupContext } from './context'

type Props = {
  name?: string
  value: string[]
  onChange?: (list: string[]) => void
} & DefaultProps

/**
 * @deprecated 향후 ds-2024 Group 으로 마이그 예정. 신규 호출은 자제.
 */
const _CheckboxGroup = ({ value, onChange, children, className, style, name }: Props) => {
  const [chipStore] = useState(new Set([] as string[]))
  const [_value, _setValue] = useState(new Set(value))
  const [isAllCheck, setIsAllCheck] = useState(false)

  useEffect(() => {
    _setValue(new Set(value))
  }, [value])

  useEffect(() => {
    setIsAllCheck(chipStore.size === _value.size)
  }, [chipStore, _value])

  const onCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const _newValue = new Set(_value)

    _newValue.has(e.target.value) ? _newValue.delete(e.target.value) : _newValue.add(e.target.value)

    onChange?.(Array.from(_newValue))
    _setValue(_newValue)
  }

  const onChangeALLItemCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isALLItemChecked = e.target.checked
    const _newValue = new Set(isALLItemChecked ? chipStore : [])

    setIsAllCheck(isALLItemChecked)

    onChange?.(Array.from(_newValue))
    _setValue(_newValue)
  }

  const addToValue = (value: string) => {
    _value.add(value)
  }

  const registChipStore = (value: string) => {
    chipStore.add(value)
  }

  return (
    <CheckboxGroupContext.Provider
      value={{
        name,
        value: _value,
        isAllCheck,
        addToValue,
        registChipStore,
        onCheckboxChange,
        onChangeALLItemCheck,
      }}
    >
      <div className={className} style={style} css={S.basic}>
        {children}
      </div>
    </CheckboxGroupContext.Provider>
  )
}

export default _CheckboxGroup
